import BaseObject from '../../../base/base_object';
import RestrictionsPool from '../pool/restrictions_pool';
import Event from '../../../utils/event';
import {SYSTEM_EVENTS} from '../../../events/events';
import ServiceFactory from '../../service_factory';
import IRestrictionsPool from '../pool/restrictions_pool_interface';
import IRestrictionsStrategyBase from './restrictions_strategy_base_interface';


export default abstract class RestrictionsStrategyBase extends BaseObject implements IRestrictionsStrategyBase {
  static CLASS = 'RestrictionsStrategyBase';
  //protected _serviceFactory: ServiceFactory;
  protected _serviceFactoryCallback: () => ServiceFactory;
  protected abstract getRestrictionsPool(): IRestrictionsPool;

  init(params) {
    super.init(params);
    this._serviceFactoryCallback = params.getServiceFactoryCallback;
  }

  protected get _serviceFactory(): ServiceFactory {
    return this._serviceFactoryCallback();
  }

  public get restrictionsPool(): IRestrictionsPool {
    return this.getRestrictionsPool();
  }

  doAsyncJobs() {
    return Promise.resolve();
  }

  public setRestrictions(restrictions: any): void {

  }

  protected _createRestrictionsPool(restrictionsByAction: any[]): IRestrictionsPool {
    restrictionsByAction = restrictionsByAction || [];
    return RestrictionsPool.create({
      serviceFactory: this._serviceFactory,
      restrictionsByAction: restrictionsByAction
    });
  }

  public getGameRestriction(gameType: number, gameGroupId: number): any {
    return this.restrictionsPool.getGameRestriction(gameType, gameGroupId);
  }

  public isApplicationRestricted(): boolean {
    if(this.restrictionsPool.isPackageRestrictedForOpen()) {
      this.logger.warn('Application is restricted because of package restriction for OpenApplication. Current product package ID is: ' + this._serviceFactory.skinService().getProductPackageID());
      this._sendRestrictionAnalytics('OpenPackageRestriction', this._serviceFactory.skinService().getProductPackageID());
      return true;
    }

    if(this.restrictionsPool.isSubBrandRestrictedForOpen()) {
      this.logger.warn('Application is restricted because of sub brand restriction for OpenApplication. Current sub brand ID is ' + this._serviceFactory.skinService().getSubBrandID());
      this._sendRestrictionAnalytics('OpenSubBrandRestriction', this._serviceFactory.skinService().getSubBrandID());
      return true;
    }

    return false;
  }

  private _sendRestrictionAnalytics(label: string, value: number): void {
    const analyticsData = {
      category: '[Technical-event]',
      action: 'Restrictions',
      label: label,
      value: value
    };

    Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticsData)
  }

}